import { footerSections } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">爱黑料网</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              入口导航型专题合集站，专注同步可用线路与新地址，让你不再为打不开、找不到入口而折腾。
            </p>
            <div className="mt-5 flex items-center gap-2 flex-wrap">
              <span className="flex items-center gap-1.5 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-200">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary-300 animate-pulse-dot"></span>
                线路校验正常
              </span>
              <span className="rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-200">
                可用率 99.2%
              </span>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-heading text-base font-semibold text-background-50">
                {section.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {section.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#entries"
                      className="cursor-pointer text-sm text-background-200/80 transition-colors hover:text-accent-400"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">
            © 2026 爱黑料网 · 本站为静态导航展示页，内容与线路信息以实际更新为准
          </p>
          <p className="text-xs text-background-200/70">
            本页仅作线路状态展示，不收集任何个人信息
          </p>
        </div>
      </div>
    </footer>
  );
}